import type { TenantConfig } from '@/types/TenantConfig'

export const msichicago: TenantConfig = {
  logo: 'assets/msichicago/static/logo.svg',
  cartThemeMode: 'dark',
  themeOptions: {
    dialog: {
      headerBackground: 'linear-gradient(90deg,#143a75,#0a1f54)',
      headerTextColor: '#ffffff',
      headerIconColor: '#ffffff',
      headerBorder: '1px solid hsla(0,0%,100%,.2)',
    },
    mobileFooter: {
      backgroundColor: '#0a1f54',
      textColor: '#ffffff',
      priceTextColor: '#ffffff',
      cartButtonBackgroundColor: 'transparent',
      cartButtonHoverBackgroundColor: 'transparent',
      cartButtonIconColor: 'hsla(0,0%,100%,.6)',
      cartButtonBorder: '1px solid hsla(0,0%,100%,.6)',
    },
  },
  teaserImageSize: {
    width: 304,
    height: 304,
  },
  postCodeAsDiscountCode: {
    filter: 'US',
  },
  componentOptions: {
    eventListingWithFilters: {
      timeFilters: true,
      hideCategoryFilters: true,
    },
    eventDetailRoute: {
      eventNameTitlePosition: 'inside content',
    },
    selectDate: {
      inlineDatePicker: true,
      inlineDatePickerColumns: 1,
    },
    reserveDateFirst: {
      inlineDatePicker: true,
    },
    selectQuantities: {
      showTicketTypeHeaders: true,
    },
    buyMembership: {
      skipUpsells: true,
    },
    cartWidget: {
      dateTimeFormat: 'ddd, MMM D, YYYY @ h:mm A',
      showTicketGroupName: true,
    },
    stripeCreditCard: {
      fontFaceStylesheet: '/assets/msichicago/static/fonts.css',
    },
  },
  i18nOverrides: {
    en: {
      checkoutRoute: {
        title: 'We need some information about you',
      },
      contextualEventTitles: {
        anchor:
          'Tell us about your visit <span class="subtitle">Choose a date and tickets that best suit your plans</span>',
        giftCard: 'Buy a Gift Card <span class="subtitle">Give the gift of MSI</span>',
        membership: 'Become a member <span class="subtitle">Enjoy all that MSI has to offer</span>',
        membershipGift:
          'Gift of Membership <span class="subtitle">Looking for the perfect gift<br />Give a year-long membership to all the science lovers in your life.</span>',
        membershipRenew: 'Renew your membership <span class="subtitle">Keep enjoying all that MSI has to offer</span>',
      },
      applyGiftCards: {
        giftCardNotFound: 'Gift card not found.',
      },
      applyGiftCardsModal: {
        giftCardNumberLabel: 'Gift Card Number',
      },
      reserveDateFirst: {
        title: 'When do you plan to visit us?',
      },
      selectAvailableSession: {
        title: 'What time would you like to attend?',
      },
      selectQuantities: {
        title: 'Who’s coming to the museum?',
      },
      stepperGroupTitles: {
        members: 'Member Tickets',
        guests: 'Non-Member Tickets',
        default: '',
      },
      conflictTimes: 'The following times conflict with your other tickets: ',
      soldOutTimes: 'The following times are sold out: ',
    },
  },
}
